import { Alert, message, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spin } from 'antd';
import {
  bulkDeleteBidders,
  checkBriefingAttendants,
  createBidders,
  createTempBidders,
  getPrequalificationData,
  sendBidInvitation,
} from '../../api/constlink';
import BidderListComponent from '../../components/bidders/BidderListComponent';
import { RootState } from '../../modules';
import { deleteBidderAsync, getBidderListAsync } from '../../modules/bidders';
import ImportBiddersModal from '../../components/bidders/ImportBiddersModal';
import UploadBiddersModal from '../../components/bidders/UploadBiddersModal';
import SearchBiddersModal2 from '../../components/bidders/SearchBiddersModal2';
interface BidderListContainerProps {
  enterpriseId: string;
  projectId: string;
  bidPackageId: string;
}
function BidderListContainer({
  enterpriseId,
  projectId,
  bidPackageId,
}: BidderListContainerProps) {
  const [visible0, setVisible0] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);

  const [type3ChoiceData, setType3ChoiceData] = useState<any>();

  const history = useHistory();
  const { data, loading, error } = useSelector(
    (state: RootState) => state.bidders.bidders,
  );
  const bidPackage = useSelector(
    (state: RootState) => state.bidPackages.bidPackage.data,
  );
  const [visibleAlert, setVisibleAlert] = useState<string | null>(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getBidderListAsync.request({ enterpriseId, projectId, bidPackageId }),
    );
  }, [dispatch, enterpriseId, projectId, bidPackageId]);

  useEffect(() => {
    (async () => {
      const prequalificationData = await getPrequalificationData({
        enterpriseId,
      });
      if (prequalificationData === null) return;
      setType3ChoiceData({
        subcontractTypeChoiceList: [
          ...prequalificationData.basicTemplate.schema.allOf[0].then.properties
            .general.properties.type3.items.enum,
        ],
        materialTypeChoiceList: [
          ...prequalificationData.basicTemplate.schema.allOf[0].else.properties
            .general.properties.type3.items.enum,
        ],
      });
    })();
  }, [enterpriseId]);

  const onCreate = async (vendorIdList: number[]) => {
    await createBidders({
      enterpriseId,
      projectId,
      bidPackageId,
      vendorIdList,
    });
    dispatch(
      getBidderListAsync.request({ enterpriseId, projectId, bidPackageId }),
    );
    setVisible0(false);
    setVisible1(false);
  };

  const onCreateTempBidder = async (tempBidders: any[]) => {
    await createTempBidders({
      enterpriseId,
      projectId,
      bidPackageId,
      tempBidders,
    });
    setVisible2(false);
    dispatch(
      getBidderListAsync.request({ enterpriseId, projectId, bidPackageId }),
    );
  };

  const moveToBidderDetailPage = (bidderId: number) => {
    history.push(`${bidPackageId}/bidders/${bidderId}`);
  };

  const addBidders = (type: string) => {
    if (type === '0') setVisible0(true);
    else if (type === '1') setVisible1(true);
    else if (type === '2') setVisible2(true);
  };

  const onDelete = (bidderId: string) => {
    dispatch(
      deleteBidderAsync.request({
        enterpriseId,
        projectId,
        bidPackageId,
        bidderId,
      }),
    );
  };

  const _sendBidInvitation = async (selectedValues: number[]) => {
    if (
      bidPackage &&
      bidPackage.isSovIncluded === true &&
      bidPackage.bidPackageLineItems.length === 0
    ) {
      setVisibleAlert(
        '공내역서가 존재하지 않습니다. 내역서 탭으로 이동하여 공내역서를 생성 하세요.',
      );
      return;
    }

    const results: any[] = await sendBidInvitation({
      enterpriseId,
      projectId,
      bidPackageId,
      bidderIdList: selectedValues,
    });
    const sentCount = results.filter((item) => item.isSent === true).length;
    if (sentCount === 0) {
      message.warning('문자/이메일 이 발송되지 않았습니다.');
    } else {
      message.success(`${sentCount} 개의 문자/이메일 이 발송 되었습니다.`);
    }

    dispatch(
      getBidderListAsync.request({ enterpriseId, projectId, bidPackageId }),
    );
  };

  const _bulkDeleteBidders = async (selectedValues: number[]) => {
    const res = await bulkDeleteBidders({
      enterpriseId,
      projectId,
      bidPackageId,
      bidderIdList: selectedValues,
    });
    if ('deletedBidderCount' in res) {
      Modal.success({
        content: `참여 업체 ${res.deletedBidderCount} 개가 삭제 되었습니다.`,
      });
      dispatch(
        getBidderListAsync.request({ enterpriseId, projectId, bidPackageId }),
      );
    } else
      Modal.error({
        content: `참여 업체 삭제를 실패 하였습니다.`,
      });
  };

  const _checkBriefingAttendants = async (type: boolean, idList: number[]) => {
    try {
      await checkBriefingAttendants({
        enterpriseId,
        projectId,
        bidPackageId,
        data: {
          type,
          idList,
        },
      });
      dispatch(
        getBidderListAsync.request({ enterpriseId, projectId, bidPackageId }),
      );
    } catch (error: any) {
      Modal.error({
        content: `${error.response.data.message}`,
      });
    }
  };

  return (
    <>
      {loading && <Spin />}
      {error && (
        <Alert
          message={`${error.response?.data.message}`}
          type="error"
          showIcon
          closable
        />
      )}
      {visibleAlert && (
        <Alert
          message={`${visibleAlert}`}
          style={{ marginBottom: '10px' }}
          type="error"
          showIcon
          closable
          onClose={() => setVisibleAlert(null)}
        />
      )}
      {bidPackage && data && (
        <BidderListComponent
          bidders={data}
          isBriefing={bidPackage.isBriefing}
          moveToBidderDetailPage={moveToBidderDetailPage}
          addBidders={addBidders}
          onDelete={onDelete}
          sendBidInvitation={_sendBidInvitation}
          checkBriefingAttendants={_checkBriefingAttendants}
          bulkDeleteBidders={_bulkDeleteBidders}
        />
      )}
      {data && visible0 && (
        <SearchBiddersModal2
          visible={visible0}
          enterpriseId={enterpriseId}
          projectId={projectId}
          existingCollaborators={data}
          type3ChoiceData={type3ChoiceData}
          onCreate={onCreate}
          onCancel={() => {
            setVisible0(false);
          }}
        />
      )}
      {data && visible1 && (
        <ImportBiddersModal
          visible={visible1}
          enterpriseId={enterpriseId}
          projectId={projectId}
          existingCollaborators={data}
          onCreate={onCreate}
          onCancel={() => {
            setVisible1(false);
          }}
        />
      )}
      {data && visible2 && (
        <UploadBiddersModal
          visible={visible2}
          onFinish={onCreateTempBidder}
          onCancel={() => {
            setVisible2(false);
          }}
        />
      )}
    </>
  );
}

export default BidderListContainer;
